import { UserLoginAction } from "../../actions/UserLoginAction";
import { CallOverVerificationAction } from "../../actions/vendor/CallOverVerificationAction";
import { CallOverBankDetails } from "../../models/CallOverBankDetails";

export interface CallOverVerificationState {
  requestId: number,
  requestTypeId: number,
  vendorId: number,
  vendorName: string,
  vendorTypeCode: string,
  nameOfTheContactedPerson: string,
  designationOftheContactedPerson: string,
  emailAddress: string[],
  bankDetails: CallOverBankDetails[],
  contactName:string,
  contactPersonNames: string[],
  callerVerifierDesignation: string,
  vendorCountry: string,
  vendorStreet : string,
  vendorPostalCode: string,
  vendorCity: string,
  contactNumber: string,
  contactNumbers: string[],
  vendorBR:string,
  preferedCommMethod: string
}

const initialState = {
  requestId: 0,
  requestTypeId: 0,
  vendorId: 0,
  vendorName: "",
  vendorTypeCode: "",
  bankAccountNo: "",
  accountHolderName: "",
  bankName: "",
  bankBranch: "",
  swiftCode: "",
  nameOfTheContactedPerson: "",
  designationOftheContactedPerson: "",
  emailAddress: [],
  bankDetails: [],
  contactName: "",
  contactPersonNames: [],
  callerVerifierDesignation: "",
  vendorStreet : "",
  vendorPostalCode: "",
  vendorCity: "",
  vendorCountry: "",
  contactNumber: "",
  contactNumbers: [],
  vendorBR: "",
  preferedCommMethod: ""
};

export function CallOverVerificationReducer(
  state: CallOverVerificationState = initialState,
  action: CallOverVerificationAction
): CallOverVerificationState {
  switch (action.type) {
    case "ON_ENTERING_CALL_OVER_VERIFICATION_DATA":
      return {
        ...state,
        [action.payload[0]]: action.payload[1],
      };
    case "ON_ENTERING_CALL_OVER_BANK_VERIFICATION_DATA":
      let index = action.payload[1];
      let items = [...state.bankDetails];
      let item = { ...items[index] };
      item[action.payload[0] as keyof CallOverBankDetails] = action.payload[2];
      state.bankDetails[index] = item;
      return {
        ...state,
        bankDetails: [
          ...state.bankDetails,
        ]
      };
    case "ON_ENTERING_CALL_OVER_VERIFICATION_EMAIL":
      return {
        ...state,
        emailAddress: state.emailAddress.map((row, index) => {
          if (index === action.payload[1]) {
            return action.payload[2];
          }
          return row;
        }),
      };

    case "ADD_EMPTY_CALL_OVER_VERIFICATION_EMAIL":
      let emptyArray = new Array<string>(action.payload[0]);
      for (var i = 0; i < action.payload[0]; i++) {//check
        emptyArray.push("");
      }
      return {
        ...state,
        emailAddress: [...state.emailAddress, ...emptyArray]
      };

    case "ADD_EMPTY_CALL_OVER_VERIFICATION_BANKS":
      let emptyBArray = new Array<CallOverBankDetails>();
      for (var i = 0; i < action.payload[0]; i++) {
        emptyBArray.push(new CallOverBankDetails("", "", "", "", ""));
      }
      return {
        ...state,
        bankDetails: [...state.bankDetails, ...emptyBArray]
      };

    case "RESET_CALLOVER":
      return Object.assign(state, initialState);
    default:
      return state;
  }
}